import { Grid, Box } from "@mui/material";
import styles from "./AddFarmBillingEntity.module.scss";
import InputTextField from "../../components/TextField";
import { useAddFarm } from "../../hooks/useAddFarmBillingEntity";

export const LandlordName = () => {
  const {
    newFarmName,
    farmNameError,
    handlefarmNameChange,
    handleSaveFarmName,
  } = useAddFarm();

  return (
    <div className={styles.formContainer}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <InputTextField
            label="Landlord"
            placeholder="Enter Landlord"
            name="farmName"
            value={newFarmName.farmName}
            onChange={handlefarmNameChange}
            className={styles.inputText}
            error={!!farmNameError}
            helperText={farmNameError}
          />
        </Grid>
        <Grid item>
          <Box display="flex" alignItems="flex-end" height="73%">
            <button className={styles.saveButton} onClick={handleSaveFarmName}>
              Add
            </button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};
